// src/services/axiosAuth.js
import axios from 'axios';

const axiosAuth = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

axiosAuth.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_cliente');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Si el token expiró redirige al login automáticamente
axiosAuth.interceptors.response.use(
    (response) => response,
    (error) => {
        const mensaje = error.response?.data?.message;
        // Solo redirige si no hay token — si expiró lo maneja el componente
        if (error.response?.status === 401 && mensaje === 'Acceso denegado. Token no proporcionado.') {
            localStorage.removeItem('auth_cliente');
            localStorage.removeItem('sucursal');
            localStorage.removeItem('admin');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosAuth;